<template>
    <span v-html="inStock ? value : 'SOLD OUT'" v-bind:style="{'color': !inStock ? 'red' : ''}"></span>
</template>
<script>
    export default {
        props: {
            value: {
                type: String,
                required: true
            },
            schedule: {
                type: Number,
                required: true
            }
        },

        data: () => ({
            inStock: true
        }),

        mounted() {
            this.getStatus()
        },

        methods: {
            getStatus() {
                axios.post('/events/status', {
                    schedule: this.schedule
                })
                .then(response => {
                    this.inStock = response.data.inStock
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/Price.vue